import { render, staticRenderFns } from "./admin-layout.vue?vue&type=template&id=3cf11bbb"
import script from "./admin-layout.vue?vue&type=script&lang=js"
export * from "./admin-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports